import { MatDialog } from '@angular/material/dialog';
import { PrintMapComponent } from './../../print-map/print-map.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ebw-print-map-control',
  templateUrl: './print-map-control.component.html',
  styleUrls: ['./print-map-control.component.scss']
})
export class PrintMapControlComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  openMap() {
    this.dialog.open(PrintMapComponent, { width: '95vw', height: '95vh', maxWidth: '95vw', disableClose: true });
  }
}
